import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './assets/languages/en';
import ar from './assets/languages/ar';
import cooperative from './assets/languages/cooperative';
import { getDefaultLanguage } from 'core/services/language';

const defaultLanguage = getDefaultLanguage();

const cloneResources = <T>(resources: T): T => JSON.parse(JSON.stringify(resources));

// set default language on first load if not exist
if (!localStorage.getItem('language')) {
	localStorage.setItem('language', 'en');
}

i18n.use(initReactI18next).init({
	resources: { en: cloneResources(en), ar: cloneResources(ar) },
	lng: defaultLanguage,
	fallbackLng: defaultLanguage,
	interpolation: {
		escapeValue: false,
	},
	react: {
		bindI18nStore: 'added',
	},
});

/** Switch the platform terminology between companies and cooperative societies. */
export const applyCooperativeTranslations = (isCooperative: boolean) => {
	const resources = isCooperative ? cooperative : { en, ar };

	i18n.addResourceBundle('en', 'translation', cloneResources(resources.en.translation), true, true);
	i18n.addResourceBundle('ar', 'translation', cloneResources(resources.ar.translation), true, true);
};

export default i18n;
